import * as React from 'react';
import {
  Dialog,
  DialogContent,
} from '@material-ui/core';
import { useSnackbar } from 'notistack';
import type { IAddRepairJob, IRepairItem } from './EstimatorInterfaces';
import EstimatorUpsertRepairJobs from './EstimatorUpsertRepairJob';

interface EditRepairJobDialogProps {
  onClose: () => void;
  showModal: boolean;
  key: number;
  repairItems: IRepairItem[];
  handleEditRepairJob: (jobId: string, repairJobParam: IAddRepairJob) => Promise<unknown>;
  editJobId: string;
  editJob?: IAddRepairJob;
  barcode: string;
  loading: boolean;
}

const EditRepairJobDialog: React.FC<EditRepairJobDialogProps> = ({
  showModal, onClose, repairItems, handleEditRepairJob, key, editJob, editJobId, barcode, loading,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const handleEditRepairJobSubmit = (addRepairJobParam: IAddRepairJob) => {
    handleEditRepairJob(editJobId, addRepairJobParam)
      .then(() => onClose())
      .catch((error) => enqueueSnackbar(JSON.stringify(error), { persist: false, variant: 'error' }));
  };

  return (
    <Dialog
      onClose={onClose}
      open={showModal}
      fullWidth
      maxWidth="md"
    >
      <DialogContent>
        <EstimatorUpsertRepairJobs
          key={key}
          barcode={barcode}
          handleAddRepairJob={handleEditRepairJobSubmit}
          repairItems={repairItems}
          editJob={editJob}
          loading={loading}
        />
      </DialogContent>
    </Dialog>
  );
};

export default EditRepairJobDialog;
